// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HomeFilledSvg from "@ant-design/icons-svg/es/asn/HomeFilled";
import AntdIcon from '../components/AntdIcon';

var HomeFilled = function HomeFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: HomeFilledSvg
  }));
};

HomeFilled.displayName = 'HomeFilled';
export default React.forwardRef(HomeFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/HomeFilled.js
// module id = 1315
// module chunks = 0